import { LeadSource } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { BadgeColors, BadgeColorsProps } from '../components/Badge'

export const leadSourceLabel: Record<string, string> = {
  [LeadSource.acqDirect]: 'ACQ Direct',
  [LeadSource.airBnb]: 'Airbnb',
  AirBnB: 'Airbnb',
  [LeadSource.allegiantAir]: 'Allegiant Air',
  [LeadSource.beachGirls]: 'Beach Girls',
  [LeadSource.beachside]: 'Beachside',
  [LeadSource.blueGround]: 'Blueground',
  [LeadSource.bnbFinder]: 'Savvy-bnbfinder',
  [LeadSource.bonotel]: 'Bonotel',
  [LeadSource.bookingCom]: 'Booking.com',
  [LeadSource.bravo]: 'Bravo',
  [LeadSource.capitalOne]: 'Capital One',
  [LeadSource.expedia]: 'Expedia',
  [LeadSource.frontdesk]: 'FrontDesk',
  [LeadSource.gilmore]: 'The Gilmore',
  [LeadSource.google]: 'Google',
  [LeadSource.googleTravel]: 'Google Travel',
  [LeadSource.homeAway]: 'VRBO',
  [LeadSource.homesAndVillas]: 'Homes & Villas',
  [LeadSource.homeToGo]: 'HomeToGo',
  [LeadSource.hopper]: 'Hopper',
  [LeadSource.hotelTonight]: 'HotelTonight',
  [LeadSource.lakecations]: 'Lakecations',
  [LeadSource.lighthouse]: 'Lighthouse',
  [LeadSource.maimonGroup]: 'Maimon Group',
  [LeadSource.mara]: 'The Mara',
  [LeadSource.marriott]: 'Marriott',
  [LeadSource.mobile]: 'AvantStay App',
  [LeadSource.monkeyTree]: 'Monkey Tree',
  [LeadSource.nexo]: 'Nexo',
  [LeadSource.nonPayingGuest]: 'VIP',
  [LeadSource.other]: 'Other',
  [LeadSource.overmoon]: 'Overmoon',
  [LeadSource.pasoRoblesVr]: 'Paso Robles VR',
  [LeadSource.plumGuide]: 'Plum Guide',
  [LeadSource.quintess]: 'Quintess',
  [LeadSource.reconline]: 'Reconline',
  [LeadSource.rentalsUnited]: 'Rentals United',
  [LeadSource.stayHvn]: 'Stay HVN',
  [LeadSource.staySense]: 'StaySense',
  [LeadSource.theWeekend]: 'The Weekend',
  [LeadSource.theWesley]: 'The Wesley',
  [LeadSource.theCode]: 'The Code',
  [LeadSource.theSense28]: 'Sense28',
  [LeadSource.topVillas]: 'Top Villas',
  [LeadSource.travelStaytion]: 'TravelStaytion',
  [LeadSource.tripAdvisor]: 'Trip Advisor',
  [LeadSource.vacationRenter]: 'VacationRenter',
  [LeadSource.voyage]: 'Voyage',
  [LeadSource.vrbo]: 'VRBO',
  [LeadSource.wander]: 'Wander',
  [LeadSource.website]: 'Avantstay.com',
  [LeadSource.whimstay]: 'Whimstay',
  [LeadSource.yieldPlanet]: 'Yield Planet',
}

export const badgeColorByLeadSource: Record<string, BadgeColorsProps> = {
  [LeadSource.acqDirect]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.airBnb]: BadgeColors.channelAirbnb,
  [LeadSource.allegiantAir]: BadgeColors.channelAllegiantAir,
  [LeadSource.beachGirls]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.beachside]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.blueGround]: BadgeColors.channelBlueGround,
  [LeadSource.bnbFinder]: BadgeColors.channelSavvy,
  [LeadSource.bonotel]: BadgeColors.channelBonotel,
  [LeadSource.bookingCom]: BadgeColors.channelBookingCom,
  [LeadSource.bravo]: BadgeColors.channelWebsite,
  [LeadSource.capitalOne]: BadgeColors.channelWebsite,
  [LeadSource.expedia]: BadgeColors.channelExpedia,
  [LeadSource.frontdesk]: BadgeColors.channelFrontdesk,
  [LeadSource.gilmore]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.google]: BadgeColors.channelGoogle,
  [LeadSource.googleTravel]: BadgeColors.channelGoogleTravel,
  [LeadSource.homeAway]: BadgeColors.channelVRBO,
  [LeadSource.homesAndVillas]: BadgeColors.channelHomesAndVillas,
  [LeadSource.homeToGo]: BadgeColors.channelHomeToGo,
  [LeadSource.hopper]: BadgeColors.channelHopper,
  [LeadSource.hotelTonight]: BadgeColors.channelHotelTonight,
  [LeadSource.lakecations]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.lighthouse]: BadgeColors.channelLighthouse,
  [LeadSource.maimonGroup]: BadgeColors.channelMarriott,
  [LeadSource.mara]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.marriott]: BadgeColors.channelMarriott,
  [LeadSource.mobile]: BadgeColors.channelMobile,
  [LeadSource.monkeyTree]: BadgeColors.channelOther,
  [LeadSource.nexo]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.nonPayingGuest]: BadgeColors.channelNonPayingGuest,
  [LeadSource.other]: BadgeColors.channelOther,
  [LeadSource.overmoon]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.pasoRoblesVr]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.plumGuide]: BadgeColors.warning,
  [LeadSource.quintess]: BadgeColors.channelQuintess,
  [LeadSource.reconline]: BadgeColors.warning,
  [LeadSource.rentalsUnited]: BadgeColors.channelRentalsUnited,
  [LeadSource.stayHvn]: BadgeColors.channelStayHvn,
  [LeadSource.staySense]: BadgeColors.warning,
  [LeadSource.theWeekend]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.theWesley]: BadgeColors.channelTheWesley,
  [LeadSource.theCode]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.theSense28]: BadgeColors.channelAcquisitionWebsites,
  [LeadSource.topVillas]: BadgeColors.channelTheWesley,
  [LeadSource.travelStaytion]: BadgeColors.channelTravelStaytion,
  [LeadSource.tripAdvisor]: BadgeColors.channelTripAdvisor,
  [LeadSource.vacationRenter]: BadgeColors.channelVacationRenter,
  [LeadSource.voyage]: BadgeColors.channelVoyage,
  [LeadSource.vrbo]: BadgeColors.channelVRBO,
  [LeadSource.wander]: BadgeColors.channelWander,
  [LeadSource.website]: BadgeColors.channelWebsite,
  [LeadSource.whimstay]: BadgeColors.channelOther,
  [LeadSource.yieldPlanet]: BadgeColors.channelYieldPlanet,
}

export const labelByChannelSource = {
  Airbnb: 'Airbnb',
  HomeAway: 'HomeAway',
  Vrbo: 'VRBO',
  'Booking Com': 'Booking.com',
  Direct: 'Direct',
}

export const directLeadSources = [
  LeadSource.acqDirect,
  LeadSource.beachGirls,
  LeadSource.beachside,
  LeadSource.gilmore,
  LeadSource.lakecations,
  LeadSource.lighthouse,
  LeadSource.mara,
  LeadSource.mobile,
  LeadSource.monkeyTree,
  LeadSource.nexo,
  LeadSource.overmoon,
  LeadSource.pasoRoblesVr,
  LeadSource.theWeekend,
  LeadSource.theWesley,
  LeadSource.theCode,
  LeadSource.theSense28,
  LeadSource.voyage,
  LeadSource.website,
]

export const replyableReviewLeadSources = [LeadSource.airBnb, LeadSource.vrbo]
